module.exports = __webpack_public_path__ + "static/media/filters.styles.abd9ff67.less";